import React, { createContext, useState, useEffect } from "react";
import { ShowToast, Severty } from "../helper/toast";
import apiPath from "../constants/apiPath";
import axios from "axios";
import {
  connectMainSocket,
  disconnectMainSocket,
} from "../adminSessionSocket";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [session, setSession] = useState({ token: null });
  const [userProfile, setUserProfile] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let token = localStorage.getItem("token");
    let storedProfile = localStorage.getItem("userProfile") || localStorage.getItem("user");

    if (token) {
      setSession({ token });
      setIsLoggedIn(true);
      
      // Connect websocket if token is present
      connectMainSocket(token);

      if (storedProfile) {
        try {
          const parsedUser = JSON.parse(storedProfile);
          setUserProfile(parsedUser);
        } catch (e) {
          console.error("Error parsing stored user profile:", e);
        }
      }
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    if (!userProfile) return;
  }, [userProfile]);

  useEffect(() => {
    if (!isLoggedIn) return;
  }, [isLoggedIn]);

  const login = () => {
    setIsLoggedIn(true);
    return;
  };

  const logout = async () => {
    try {
      const refresh = localStorage.getItem("refreshToken");
      const sessionId = localStorage.getItem("session_id");
      const token = localStorage.getItem("token");
      setLoading(true);
      const response = await axios.post(`${apiPath.baseURL}/auth/logout`,
        {
          refresh: refresh,
          session_id: sessionId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setLoading(false);
        disconnectMainSocket();
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("session_id");
        localStorage.removeItem("live_notifications");
        localStorage.removeItem("userProfile");
        localStorage.removeItem("sessionEncryptionKey");
        ShowToast("Logout Successfully", Severty.SUCCESS);
        // Let the toast render before leaving the page.
        setTimeout(() => {
          window.location.assign("/login");
        }, 1200);
      }
    } catch (error) {
      console.log("Error occured while logout admin", error);
      setLoading(false);
      ShowToast("Unable to logout. Please try again.", Severty.ERROR);
    }
  };

  useEffect(() => {
    if (!isLoggedIn) return;

    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      if (payload.exp) {
        const expiryTime = payload.exp * 1000;
        const currentTime = Date.now();
        const timeLeft = expiryTime - currentTime;

        if (timeLeft <= 0) {
          ShowToast("Session expired. Please log in again.", Severty.WARNING);
          logout();
        } else {
          const timeoutId = setTimeout(() => {
            ShowToast("Session expired. Please log in again.", Severty.WARNING);
            logout();
          }, timeLeft);

          return () => clearTimeout(timeoutId);
        }
      }
    } catch (e) {
      console.error("Error decoding token for expiry", e);
    }
  }, [isLoggedIn]);

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        session,
        setSession,
        userProfile,
        setUserProfile,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
